export enum Accounting {
	ConfirmationConfirm = 'Accounting::confirmation.confirm',
	ConfirmationIndex = 'Accounting::confirmation.index',
	FactorIndex = 'Accounting::factor.index',
	FactorShow = 'Accounting::factor.show',
	GatewayIndex = 'Accounting::gateway.index',
	GatewayShow = 'Accounting::gateway.show',
	GatewayUpdate = 'Accounting::gateway.update',
	GatewayUpdateStatus = 'Accounting::gateway.update_status',
	PaymentIndex = 'Accounting::payment.index',
	PaymentShow = 'Accounting::payment.show',
	SettlementIndex = 'Accounting::settlement.index',
	SettlementShow = 'Accounting::settlement.show',
	SettlementUpdateStatus = 'Accounting::settlement.update_status',
	TransactionCreate = 'Accounting::transaction.create',
	TransactionIndex = 'Accounting::transaction.index',
	TransactionMyTransaction = 'Accounting::transaction.my-transaction',
	TransactionShow = 'Accounting::transaction.show',
	WalletIndex = 'Accounting::wallet.index',
	WalletShow = 'Accounting::wallet.show',
}
